/**
 * Csv Schema of Faturamento
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {Faturamento} from '@/model/resource/Faturamento'
import {FormatHelper} from '@/helpers/FormatHelper'

export class CsvFaturamentoSchema extends Schema {
  readonly name = 'CsvFaturamento'

  readonly fieldSet: FieldSet<Faturamento> = {
    responsavel: schema => schema.model.responsavel?.$id ?? null,
    cnpj: schema => Helper.cnpj(schema.model.responsavel?.cnpj) ?? '',
    razaoSocial: schema => schema.model.responsavel?.razaoSocial ?? '',
    nomeFantasia: schema => schema.model.responsavel?.nomeFantasia ?? '',
    configDiaInicialDaGeracao: schema => schema.model.getDataInicio as string,
    configDiaFinalDaGeracao: schema => schema.model.getDataFinal as string,
    tipoRelatorio: schema => schema.model.getTipoRelatorio as string,
    dataGeracaoFaturamento: schema =>
      Helper.datetime(schema.model.dataGeracaoFaturamento),
    volumeNotasAnterior: schema => schema.model.volumeNotasAnterior ?? '',
    volumeNotas: schema => schema.model.volumeNotas ?? '',
    dataVencimentoContrato: schema =>
      Helper.date(
        schema.model.faturamentoConfiguracao?.dataVencimentoContrato
      ) ?? '',
    dataUltimaCorrecao: schema =>
      Helper.date(schema.model.faturamentoConfiguracao?.dataUltimaCorrecao) ??
      '',
    numeroProtheus: schema =>
      schema.model.faturamentoConfiguracao?.numeroProtheus ?? '',
    observacao: schema =>
      schema.model.faturamentoConfiguracao?.observacao ?? '',
    faixaCalculadaAnterior: schema => schema.model.faixaCalculadaAnterior ?? '',
    faixaCalculada: schema => schema.model.faixaCalculada ?? '',
    valorIroute: schema =>
      FormatHelper.numberToCurrency(
        schema.model.faturamentoConfiguracao?.valorIroute
      ),
    valorBi: schema =>
      FormatHelper.numberToCurrency(
        schema.model.faturamentoConfiguracao?.valorBi
      ),
    valorTorreControle: schema =>
      FormatHelper.numberToCurrency(
        schema.model.faturamentoConfiguracao?.valorTorreControle
      ),
    valorAcessoLimitadoTransportadores: schema =>
      FormatHelper.numberToCurrency(
        schema.model.faturamentoConfiguracao?.valorAcessoLimitadoTransportadores
      ),
    valorCheckinAutomatico: schema =>
      FormatHelper.numberToCurrency(
        schema.model.faturamentoConfiguracao?.valorCheckinAutomatico
      ),
    valorConsultaPedido: schema =>
      FormatHelper.numberToCurrency(
        schema.model.faturamentoConfiguracao?.valorConsultaPedido
      ),
    valorNotificacaoSMS: schema =>
      FormatHelper.numberToCurrency(
        schema.model.faturamentoConfiguracao?.valorNotificacaoSMS
      ),
    valorNotificacaoWhatsup: schema =>
      FormatHelper.numberToCurrency(
        schema.model.faturamentoConfiguracao?.valorNotificacaoWhatsup
      ),
    valorContraSenha: schema =>
      FormatHelper.numberToCurrency(
        schema.model.faturamentoConfiguracao?.valorContraSenha
      ),
    valorCheckList: schema =>
      FormatHelper.numberToCurrency(
        schema.model.faturamentoConfiguracao?.valorCheckList
      ),
    valorExibirMapaSacPainel: schema =>
      FormatHelper.numberToCurrency(
        schema.model.faturamentoConfiguracao?.valorExibirMapaSacPainel
      ),
    valorVoip: schema =>
      FormatHelper.numberToCurrency(
        schema.model.faturamentoConfiguracao?.valorVoip
      ),
  }
}
